// extracted by mini-css-extract-plugin
export default {"overlayColor":"Overlay_overlayColor__VKO7A"};